/**
 * KET Vocabulary - Personal Information Theme (74 words)
 */
import { KETWord } from './index';

export const personalInfoWords: KETWord[] = [
  { word: 'name', meaning: '名字', example: 'My name is Tom.' },
  { word: 'age', meaning: '年龄', example: 'I am ten years old.' },
  { word: 'address', meaning: '地址', example: 'My address is 123 Main Street.' },
  { word: 'birthday', meaning: '生日', example: 'My birthday is in May.' },
  { word: 'nationality', meaning: '国籍', example: 'I am Chinese.' },
  { word: 'language', meaning: '语言', example: 'I speak English and Chinese.' },
  { word: 'phone number', meaning: '电话号码', example: 'My phone number is 123-4567.' },
  { word: 'email', meaning: '电子邮件', example: 'My email is tom@email.com.' },
  { word: 'first name', meaning: '名', example: 'My first name is Tom.' },
  { word: 'surname', meaning: '姓', example: 'My surname is Smith.' },
  { word: 'family', meaning: '家庭', example: 'I love my family.' },
  { word: 'mother', meaning: '母亲', example: 'My mother is a teacher.' },
  { word: 'father', meaning: '父亲', example: 'My father works in an office.' },
  { word: 'sister', meaning: '姐妹', example: 'I have one sister.' },
  { word: 'brother', meaning: '兄弟', example: 'My brother is older than me.' },
  { word: 'grandmother', meaning: '祖母', example: 'My grandmother lives with us.' },
  { word: 'grandfather', meaning: '祖父', example: 'My grandfather tells stories.' },
  { word: 'aunt', meaning: '阿姨', example: 'My aunt lives in Shanghai.' },
  { word: 'uncle', meaning: '叔叔', example: 'My uncle is a doctor.' },
  { word: 'cousin', meaning: '堂表兄弟', example: 'My cousin is my best friend.' },
  { word: 'friend', meaning: '朋友', example: 'Tom is my best friend.' },
  { word: 'boy', meaning: '男孩', example: 'I am a boy.' },
  { word: 'girl', meaning: '女孩', example: 'She is a girl.' },
  { word: 'hello', meaning: '你好', example: 'Hello, my name is Tom.' },
  { word: 'goodbye', meaning: '再见', example: 'Goodbye! See you tomorrow.' },
  { word: 'please', meaning: '请', example: 'Please tell me your name.' },
  { word: 'thank you', meaning: '谢谢', example: 'Thank you for your help.' },
  { word: 'sorry', meaning: '对不起', example: 'Sorry, I am late.' },
  { word: 'I', meaning: '我', example: 'I am a student.' },
  { word: 'you', meaning: '你', example: 'You are my friend.' },
  { word: 'he', meaning: '他', example: 'He is my brother.' },
  { word: 'she', meaning: '她', example: 'She is my sister.' },
  { word: 'we', meaning: '我们', example: 'We are students.' },
  { word: 'they', meaning: '他们', example: 'They are my friends.' },
  { word: 'my', meaning: '我的', example: 'This is my book.' },
  { word: 'your', meaning: '你的', example: 'What is your name?' },
  { word: 'his', meaning: '他的', example: 'This is his pen.' },
  { word: 'her', meaning: '她的', example: 'This is her bag.' },
  { word: 'who', meaning: '谁', example: 'Who is that?' },
  { word: 'what', meaning: '什么', example: 'What is your name?' },
  { word: 'where', meaning: '哪里', example: 'Where do you live?' },
  { word: 'when', meaning: '什么时候', example: 'When is your birthday?' },
  { word: 'why', meaning: '为什么', example: 'Why are you happy?' },
  { word: 'how', meaning: '如何', example: 'How old are you?' },
  { word: 'one', meaning: '一', example: 'I have one brother.' },
  { word: 'two', meaning: '二', example: 'I have two sisters.' },
  { word: 'three', meaning: '三', example: 'There are three people in my family.' },
  { word: 'four', meaning: '四', example: 'I am four years old.' },
  { word: 'five', meaning: '五', example: 'I wake up at five o\'clock.' },
  { word: 'six', meaning: '六', example: 'My sister is six.' },
  { word: 'seven', meaning: '七', example: 'There are seven days in a week.' },
  { word: 'eight', meaning: '八', example: 'I am eight years old.' },
  { word: 'nine', meaning: '九', example: 'My brother is nine.' },
  { word: 'ten', meaning: '十', example: 'I am ten years old.' },
  { word: 'eleven', meaning: '十一', example: 'She is eleven.' },
  { word: 'twelve', meaning: '十二', example: 'He is twelve years old.' },
  { word: 'thirteen', meaning: '十三', example: 'My cousin is thirteen.' },
  { word: 'fourteen', meaning: '十四', example: 'I will be fourteen next year.' },
  { word: 'fifteen', meaning: '十五', example: 'There are fifteen students.' },
  { word: 'sixteen', meaning: '十六', example: 'She is sixteen.' },
  { word: 'seventeen', meaning: '十七', example: 'He is seventeen.' },
  { word: 'eighteen', meaning: '十八', example: 'My sister is eighteen.' },
  { word: 'nineteen', meaning: '十九', example: 'He is nineteen.' },
  { word: 'twenty', meaning: '二十', example: 'There are twenty students in my class.' },
  { word: 'tall', meaning: '高的', example: 'My father is tall.' },
  { word: 'short', meaning: '矮的', example: 'I am short for my age.' },
  { word: 'young', meaning: '年轻的', example: 'My sister is young.' },
  { word: 'old', meaning: '老的', example: 'My grandfather is old.' },
  { word: 'man', meaning: '男人', example: 'My father is a kind man.' },
  { word: 'woman', meaning: '女人', example: 'My mother is a beautiful woman.' },
  { word: 'child', meaning: '孩子', example: 'I am a child.' },
  { word: 'children', meaning: '孩子们', example: 'The children are playing.' },
  { word: 'people', meaning: '人们', example: 'There are many people here.' },
  { word: 'person', meaning: '人', example: 'He is a nice person.' },
];